import React from "react";
import { IconProps } from "./IconProps";

const PaperPlaneTiltIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  if (size !== "20" || thickness !== "Thin") return null;

  return (
    <svg
      aria-label={ariaLabel}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m17.5 2.5-7.2 15-2.05-5.75L2.5 9.7l15-7.2Z"
        stroke={color}
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m8.25 11.75 4-4"
        stroke={color}
        strokeWidth="1"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default PaperPlaneTiltIcon;